

// -----------------------------



import react from 'react';
import { Link } from 'react-router-dom';
import { IoIosHome } from "react-icons/io";
import { SiYoutubeshorts } from "react-icons/si";
import { MdSubscriptions ,MdFavoriteBorder} from "react-icons/md";
import { RiPlayList2Fill } from "react-icons/ri";
import { IoSettingsOutline,IoReorderThreeOutline } from "react-icons/io5";
import { BsFillInfoSquareFill } from "react-icons/bs";



const Sidebar = ({setIsDrawerVisible, isDrawerVisible})=>{
  

    return (
        <div className={`fixed sm:sticky bottom-0 sm:top-[10vh]  sm:left-8 overflow-x-hidden  w-screen sm:w-20 h-fit sm:h-72 bg-black  z-50 sm:z-20 flex sm:flex-col sm:mx-2 justify-between p-3`}>
            <button onClick={() => setIsDrawerVisible(!isDrawerVisible)} className="hidden sm:block text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><IoReorderThreeOutline /></button>

            <Link to='/'  onClick={() => window.location.reload()}>
                <button className="   text-3xl sm:text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><IoIosHome /></button>
            </Link>
            <Link to='/shorts' className='hidden sm:block '>
                <button className=" text-3xl sm:text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><SiYoutubeshorts /></button>
            </Link>
            <Link to='/watch-l'>
                <button className=" 0  text-3xl sm:text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><MdSubscriptions /></button>
            </Link>
            <Link to='/about'>
                <button className=" text-3xl sm:text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><BsFillInfoSquareFill /></button>
            </Link>
            <Link to='/settings'>
                <button className=" sm:hidden block  text-3xl sm:text-4xl text-white hover:text-red-500 rounded-md focus:text-red-700"><IoSettingsOutline /></button>
            </Link>
        </div>

    )
}
export default Sidebar;

